import { 
  PIPE_RETURN_REQUEST, 
  CREATE_PIPE_RETURN, 
  GET_PIPE_RETURNS, 
  GET_PIPE_RETURNS_PAGE, 
  UPDATE_PIPE_RETURN, 
  DELETE_PIPE_RETURN, 
  PIPE_RETURN_REQUEST_FAILURE, 
  PIPE_RETURN_REQUEST_SUCCESS 
} from '../types';

const initialState = {
  pipeReturns: [],
  pipeReturnsPage: [],
  loading: false,
  error: null,
};


const pipeReturnReducer = (state = initialState, action) => {
  switch (action.type) {
    case PIPE_RETURN_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_PIPE_RETURNS: {
      return {
        ...state,
        pipeReturns: [...action.payload],
        loading: false,
        error: null
      }
    }
    case GET_PIPE_RETURNS_PAGE: {
        const { data, total, page, pageSize, search, where } = action.payload || {};
        return {
        ...state,
        pipeReturnsPage: [...data],
        total,
        page,
        pageSize,
        search: search || '',
        where: where || {},
        loading: false,
        error: null
        }
    }
    case CREATE_PIPE_RETURN:
      return {
        ...state,
        pipeReturns: [action.payload, ...state.pipeReturns],
        loading: false,
        error: null
      };
    case UPDATE_PIPE_RETURN:
      const pipeReturnsData = state.pipeReturns.slice(0);
      const uIndex = pipeReturnsData.findIndex((data) => data.id === action.payload.id);
      pipeReturnsData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        pipeReturns: [ ...pipeReturnsData ],
        loading: false,
        error: null
      };
    case DELETE_PIPE_RETURN:
      const pipeReturns = state.pipeReturns?.slice(0);
      const index = pipeReturns.findIndex((data) => data.id === action.id);
      if (index > -1) {
        pipeReturns.splice(index, 1);
      }
      return {
        ...state,
        pipeReturns: [...pipeReturns],
        loading: false,
        error: null
      }
    case PIPE_RETURN_REQUEST_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null
      }
    }
    case PIPE_RETURN_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default pipeReturnReducer;
